import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as shortlistActions from '../../actions/shortlist';
import FilterSelect from '../../components/FilterSelect';
import { isCommonFilterDisabled } from './../../helpers/catalogueUtils';
import { shortlistStateKey } from '../../helpers/shortlistUtils';

class VendorBuyerFilters extends PureComponent {
    static propTypes = {
        refinement: PropTypes.shape({
            sellerName: PropTypes.string,
            buyerDetail: PropTypes.string
        }).isRequired,
        data: PropTypes.shape({
            sellerNameOptions: PropTypes.array.isRequired,
            buyerDetailOptions: PropTypes.array.isRequired
        }).isRequired,
        loadVendorOptions: PropTypes.func.isRequired,
        loadBuyerOptions: PropTypes.func.isRequired,
        applyShortlistVendorFilter: PropTypes.func.isRequired,
        applyShortlistBuyerFilter: PropTypes.func.isRequired
    };

    isCommonFilterDisabled() {
        return isCommonFilterDisabled(this.props.refinement);
    }

    render() {
        const {
            refinement: {
                sellerName,
                buyerDetail
            },
            data: {
                sellerNameOptions,
                buyerDetailOptions
            },
            loadVendorOptions,
            loadBuyerOptions,
            applyShortlistVendorFilter,
            applyShortlistBuyerFilter
        } = this.props;
        return (
            <div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Vendor Name</span>
                    <FilterSelect
                        title="Vendor Name"
                        alphabet
                        showSearch
                        disabled={this.isCommonFilterDisabled()}
                        value={sellerName}
                        options={sellerNameOptions}
                        onPopoverDidOpen={loadVendorOptions}
                        onChange={applyShortlistVendorFilter}
                    />
                </div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Buyer Name</span>
                    <FilterSelect
                        title="Buyer Name"
                        alphabet
                        showSearch
                        disabled={this.isCommonFilterDisabled()}
                        value={buyerDetail}
                        options={buyerDetailOptions}
                        onPopoverDidOpen={loadBuyerOptions}
                        onChange={applyShortlistBuyerFilter}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { refinement, data } = state[shortlistStateKey];
    return {
        refinement,
        data
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(shortlistActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VendorBuyerFilters);



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/VendorBuyerFiltersShortlist.js